import { FormType, IForm, IFormView } from 'shared/Form/types';

export const fields: IForm = {
  value: {
    type: FormType.TEXT,
    label: 'Значение',
    extraKey: 'value',
    value: '',
    required: true,
  },
  label: {
    type: FormType.TEXT,
    label: 'Текст',
    extraKey: 'label',
    value: '',
    required: true,
  },
};

export const view: IFormView = [
  {
    block: [['label'], ['value']],
  },
];
